// create unique keys for new enums

export enum DrawerAnalyticTitles {
  AUTOPLAN = "Autoplan",
  BIOMARKER = "Biomarker",
  CARE_CENTER_MOBILE_FILTER = "Care center mobile filter",
  CARE_CENTER_TEMPLATE = "Care center template",
  CARE_CENTER_TEMPLATES_TAB = "Care center templates tab",
  CATALOG = "Catalog",
  CATALOG_SEARCH_MOBILE_FILTER = "Catalog search mobile filter",
  COHORT = "Cohort",
  CONTINUE_WITH_APP = "Continue with app",
  CREATE_PATIENT = "Create patient",
  CURRENTLY_TAKING = "Currently taking",
  EDIT_PATIENT = "Edit patient",
  EXPERIMENT_TESTER = "Experiment tester",
  FEATURE_FLAG = "Feature flag",
  FULLSCRIPT_ASSIST = "Fullscript assist",
  LAB_DETAILS = "Lab details",
  LAB_RECOMMENDED_COLLECTION_SERVICES = "Lab recommended collection services",
  MEGAMENU = "Megamenu",
  MOBILE_MEGA_MENU_CONTENT = "Mobile mega menu content",
  NEW_CATALOG = "New catalog",
  OPTIMIZED_MEGA_MENU_MOBILE = "Optimized mega menu mobile",
  PAYMENT_METHOD = "Payment method",
  PLAN = "Plan",
  PLAN_OPTIMIZATION = "Plan optimization",
  PLAN_PREVIEW = "Plan preview",
  PREFERRED_PHLEBOTOMIST = "Preferred phlebotomist",
  PRODUCT_SWAP = "Product swap",
  SHIPPING_ADDRESS = "Shipping address",
  PATIENT_KEY_DETAILS = "Patient key details",
  PLANS = "Plans",
  ORDERS = "Orders",
  LABS = "Labs",
  TEST = "Test",
}
